import api from './index'

export function storeSave(payload, shop) {
  return api.post('config/', payload, { params: { shop } })
}
